export const clean = (value: string) => value.trim().substring(0, 5);

export const isValid = (value: string) => RegExp(/^\d{5}$/).test(value);
